
import { defineComponent } from 'vue'
import Logo from '@/components/Icons/Logo.vue'

export default defineComponent({
  components: { Logo },
})
